import styled from "styled-components";

const Container = styled.div`
  max-width: 300px;
  /* cursor: pointer; */
  padding: 16px 20px;
  border-radius: 12px;
  width: 100%;
  border: 1px solid transparent;
  transition: 300ms;
  box-shadow: rgba(46, 56, 68, 0.1) 0px 4px 12px;
  /* &:hover {
    border: 1px solid var(--neutrals-light-gray);
  } */
  @media only screen and (max-width: 620px) {
    max-width: 100%;
  }
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Ramo = styled.p`
  color: var(--neutrals-light-gray);
  font-size: 14px;
  font-weight: 700;
`;
/*const OptionButton = styled.button`
  cursor: pointer;
  display: flex;
  outline: none;
  border: none;
  background-color: transparent;
`;*/

const Title = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: var(--neutrals-charcoal);
  margin-top: 20px;
`;
const ClientName = styled.p`
  margin-top: 5px;
  color: var(--neutrals-slate-gray);
  font-size: 14px;
  margin-bottom: 5px;
`;
const Sinister = styled.p`
  color: var(--neutrals-slate-gray);
  font-size: 14px;
  margin-bottom: 15px;
`;
const LastMovement = styled.p`
  color: var(--neutrals-slate-gray);
  font-size: 10px;
  margin-bottom: 20px;
`;

//---- T A G S ----//
const TagsContainer = styled.div`
  border-top: 1px solid var(--neutrals-light-gray);
  width: 100%;
  padding: 10px 0 0 0;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
`;

const Tag = styled.button`
  cursor: pointer;
  border: 1px solid var(--secondary-maya-blue);
  background-color: var(--secondary-alice-blue);
  padding: 4px 8px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--primary-royal-blue);
  font-size: 12px;
  transition: 300ms;
  &:hover {
    opacity: 0.8;
  }
`;

export const CardRecent = ({
  id,
  ramo,
  numeroContrato,
  nombreCliente,
  estatus,
  numeroSiniestro,
  nombreContrato,
  movimientos,
}) => {
  // console.log(
  //   id,
  //   ramo,
  //   numeroContrato,
  //   nombreCliente,
  //   ultimoMovimiento,
  //   estatus,
  //   numeroSiniestro
  // );
  movimientos = movimientos || {};
  const ultimoMovimiento = Object.keys(movimientos).length ? movimientos[Object.keys(movimientos).length - 1].tipo || "Generación de siniestro" : "Generación de siniestro";
  return (
    <Container>
      <Top>
        <Ramo>{ramo}</Ramo>
      </Top>
      <Title>{nombreCliente}</Title>
      <ClientName>
        Contrato {isNaN(nombreContrato) ? "" : "#"}{String(nombreContrato).padStart(4, "0")}
      </ClientName>
      <Sinister>Siniestro #{String(numeroSiniestro).padStart(4, "0")}</Sinister>
      <LastMovement>
        {" "}
        <b>Último movimiento:</b> {ultimoMovimiento}
      </LastMovement>
      <TagsContainer>
        <Tag>Estatus: {estatus}</Tag>
      </TagsContainer>
    </Container>
  );
};
